import { useUrlQueryParam } from "./useUrlQueryParam";

type NavBarState = "collapsed" | "expanded";

export function useNavBarState(): [NavBarState, (state: NavBarState) => void] {
  const [navBarState, setNavBarState] = useUrlQueryParam<NavBarState>("nav");
  return [navBarState || "collapsed", setNavBarState];
}
